import { createTheme, responsiveFontSizes } from '@material-ui/core/styles';
import Settings from '../../settings/settings.json';

export const primary = Settings.colors.primary;
export const secondary = Settings.colors.secondary;
export const black = Settings.colors.black;
export const white = Settings.colors.white;

const baseTheme = {
  typography: {
    fontFamily: [
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    h1: { fontWeight: 500 },
    h2: { fontWeight: 500 },
    h3: { fontWeight: 500 },
    h5: { 
      fontWeight: 500,
      fontFamily: '"Roboto Mono", monospace',
    },
    body1: {
      fontFamily: '"Roboto Mono", monospace',
      fontWeight: 500,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          transition: 'background-color 0.3s ease, color 0.3s ease',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          transition: 'all 0.3s ease',
          '&:hover': {
            backgroundColor: Settings.colors.primary,
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          width: '2.5rem',
          height: '2.5rem',
          fontSize: '1.25rem',
          transition: 'all 0.3s ease !important',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontFamily: '"Roboto Mono", monospace',
          fontSize: 12,
          backgroundColor: Settings.colors.primary,
        },
      },
    },
  },
};

export const LightTheme = responsiveFontSizes(createTheme({
  ...baseTheme,
  palette: {
    mode: 'light',
    primary: {
      main: Settings.colors.primary,
    },
    secondary: {
      main: Settings.colors.secondary,
    },
    background: {
      default: Settings.colors.white,
      paper: Settings.colors.white,
    },
    text: {
      primary: Settings.colors.black,
      secondary: Settings.colors.black,
    },
  },
}));

export const DarkTheme = responsiveFontSizes(createTheme({
  ...baseTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: Settings.colors.primary,
    },
    secondary: {
      main: Settings.colors.secondary,
    },
    background: {
      default: Settings.colors.black,
      paper: Settings.colors.black,
    },
    text: {
      primary: Settings.colors.white,
      secondary: Settings.colors.white,
    },
  },
}));